import { BillingRecord } from '@/common/model/ugcBilling'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

const STATUS_MAP: Record<string, { badgeType: BadgeType; label: string }> = {
  draft: { badgeType: BadgeType.SECONDARY, label: '下書き' },
  confirmed: { badgeType: BadgeType.EMPHASIS, label: '確定' },
  invoiced: { badgeType: BadgeType.CAUTION, label: '請求済' },
  paid: { badgeType: BadgeType.SUCCESS, label: '入金済' }
}

const StatusBadge = ({ status }: { status: string }) => {
  const entry = STATUS_MAP[status] ?? STATUS_MAP.draft
  return <Badge badgeType={entry.badgeType}>{entry.label}</Badge>
}

interface Props {
  record: BillingRecord
  isScrolled: boolean
}

const BillingListRow = ({ record, isScrolled }: Props) => {
  return (
    <TableRow>
      <TableRowItem scrollShadow={isScrolled} width={128}>
        <Text size={14} weight='bold' nowrap>
          {record.billing_month}
        </Text>
      </TableRowItem>
      <TableRowItem width={200}>
        <Text size={14}>{record.site_name ?? String(record.site_id)}</Text>
      </TableRowItem>
      <TableRowItem width={160}>
        <Text size={14} color={TextColor.SECONDARY}>
          {record.plan_name ?? '-'}
        </Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>¥{record.base_amount.toLocaleString()}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14}>¥{record.usage_amount.toLocaleString()}</Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <Text size={14} weight='bold'>
          ¥{record.total_amount.toLocaleString()}
        </Text>
      </TableRowItem>
      <TableRowItem width={88}>
        <Text size={14} color={TextColor.SECONDARY}>
          {record.ugc_count.toLocaleString()}
        </Text>
      </TableRowItem>
      <TableRowItem width={128}>
        <StatusBadge status={record.status} />
      </TableRowItem>
    </TableRow>
  )
}

export default BillingListRow
